import { deliveryMenus } from "./menus";
import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Voltar",
	updateManyExternalIntegrations: {
		success: "Integrações atualizadas com sucesso",
	},
	externalStoreIntegrationStatus: {
		synced: "Sincronizado",
		pendingSyncing: "Sincronização pendente",
		pendingImporting: "Importação pendente",
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
